import {TradingAccountReportModel} from '@spa/api';

import {
    ReportTableData,
    ReportTableColumn,
    ReportTableConfigInterface
} from '../../../app/shared/components/report-table';

import {DialogButtonTypesEnum, DialogConfigInterface} from '../../../app/shared/components/dialog';

import {DisableAccountsMessages} from '../../messages';

export const DisableAccountsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountReferenceIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountTypeNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountStatusNameSelector(),
            value: null,
            hidden: false
        }),
    ];
};

export const DisableAccountsDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Account',
                selector: TradingAccountReportModel.getAccountReferenceIdSelector()
            }),
            new ReportTableColumn({
                label: 'Type',
                selector: TradingAccountReportModel.getAccountTypeNameSelector()
            }),
            new ReportTableColumn({
                label: 'Status',
                selector: TradingAccountReportModel.getAccountStatusNameSelector()
            })
        ],
        sortByRowIndex: true,
        hasToggleableOrCheckableRows: true,
        disableColumnsOptions: true,
        hiddenColumnIds: [],
        actionMenu: false
    };
};

export const DisableAccountsDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: DisableAccountsMessages.DisableAccountsSucceed.message
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
